export function userErrorMessage(error) {
    const details = typeof error?.getMessage === "function" ? error.getMessage() : error;
    const response = details?.response?.data ?? details;
    const message = response?.data?.messages ?? response?.messages ?? response?.message;
    return typeof message === "string"
        ? message
        : typeof details === "string"
            ? details
            : "Не удалось выполнить запрос. Попробуйте ещё раз.";
}
